import { Observable } from '../Observable';
import { noop } from '../util/noop';
import { createOperatorSubscriber } from './OperatorSubscriber';
import { from } from '../observable/from';
export function buffer(closingNotifier) {
    return function (source) {
        return new Observable(function (subscriber) {
            var currentBuffer = [];
            from(closingNotifier).subscribe(createOperatorSubscriber(subscriber, function () {
                var b = currentBuffer;
                currentBuffer = [];
                subscriber.next(b);
            }, noop));
            source.subscribe(createOperatorSubscriber(subscriber, function (value) { return currentBuffer.push(value); }, function () {
                subscriber.next(currentBuffer);
                subscriber.complete();
            }));
            return function () {
                currentBuffer = null;
            };
        });
    };
}
//# sourceMappingURL=buffer.js.map